<template>
    <li class="mobile_size" :title="title" :title-color="titleColor">
      <div class="card_desing mobile_size">
      <!--<div v-if="item.avatar" :style="{ backgroundImage :  'url(' + base_url +  item.avatar +')'  }"   class="card_desing__image" ></div>-->
          <div v-if="item.avatar" :style="{ backgroundImage :   'url( ' + item.avatar + ')'    }"  class="card_desing__image mobile_size" ></div>
          <div v-else  class="card_desing__image mobile_size">
              <div class="h-full w-full flex justify-center items-center mobile_size">
                 <img class="mobile_size" src="@/assets/images/not-photo.png">
              </div>
          </div>
        <div class="card_desing__overlay">
          <div class="card_desing__header">
            <svg class="card_desing__arc" xmlns="http://www.w3.org/2000/svg"><path /></svg>
            <div class="card_desing__header-text">
                <h3
                    @click="goToProfile({id: item.profileId})"
                    class="card_desing__title " :class="{'cursor-pointer': !this.hasOnlyStudentRole()}">
                    {{ item.lastName }} {{ item.firstName }}
                </h3>
               <span class="card_desing__status text-grey text-xs">
                    <a class="break-all text-black" v-if="item.email"  :href="`mailto:${ item.email }`">{{item.email}}</a>
                    <br v-else>
                </span>
            </div>
          </div>
          <div class="card_desing__description">
               <vs-button
                    v-if="user.profileId !== item.profileId"
                    color="primary"
                    @click="userMessage()"
                    icon-pack="feather"
                    icon="icon-message-square"
                    size="small"
                    class="mt-2"
                    type="filled">
                        {{$t('write_a_message')}}
                </vs-button>
          </div>
        </div>
      </div>
    </li>

</template>

<script>
import {mapState} from 'vuex'
import vueConfig from '../../../../vue.config'
import CommonMixin from "./CommonMixin";
export default {
    mixins:[CommonMixin],
    props: {
        title: {
            type: String,
            default: ''
        },
        titleColor: {
            type: String,
            default: ''
        },
        item: Object
    },
    methods: {

        userMessage() {
            this.$router.push({name: 'chat', query: {user: this.item.profileId}})
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        base_url() { return vueConfig.devServer.proxy["^/api"].target} ,
        userName() {
            // Возвращаем имя человека целиком
            return `${ this.item.lastName } ${ this.item.firstName } ${ this.item.middleName }`
        },
        avatarText() {
            // Если нет аватара подставляем инициалы
            let title,
                text = this.userName
            const textAr = text.split(' ')
            if (textAr.length) {
                const newTitle = []
                textAr.forEach(item => {
                    newTitle.push(item.substr(0, 1).toUpperCase())
                })
                title = newTitle.join('')
            } else title = text.substr(0, 1)
            return title
        }
    }
}
</script>

<style scoped lang="scss">
@media only screen and (min-width: 1000px) and (max-width: 1460px) {
    .user_label{
        display: block!important;
    }
}
</style>


<style>
@media only screen and (max-width: 992px) {
  .mobile_size {
    max-width: 150px;
    max-height: 150px;
    height: 150px;
    width: 150px;
    font-size: 10px;

  }
}
:root {
  --surface-color: #fff;
  --curve: 10;
}
.card_desing {
  position: relative;
  display: block;
  height: 100%;
  border-radius: calc(var(--curve) * 1px);
  overflow: hidden;
  text-decoration: none;
  max-width: 250px;
}
.card_desing__image {
    width: 100%;
    height: 250px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgb(195, 195, 195);
    /*color:rgb(255, 255, 255);*/
    /*font-family: "Montserrat", Helvetica, Arial, sans-serif;*/
    font-weight: 800;
    font-size: 40px;

}
.card_desing__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: calc(var(--curve) * 1px);
  background-color: var(--surface-color);
  transform: translateY(100%);
  transition: .2s ease-in-out;
}
.card_desing:hover .card_desing__overlay {
  transform: translateY(0);
}
.card_desing__header {
    position: relative;
    display: flex;
    align-items: center;
    padding:0.3em 0.3rem;
    border-radius: calc(var(--curve) * 1px) 0 0 0;
    background-color: var(--surface-color);
    transform: translateY(-100%);
    transition: .2s ease-in-out;
    justify-content: space-evenly;
}
.card_desing__arc {
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: 100%;
  right: 0;
  z-index: 1;
}
.card_desing__arc path {
  fill: var(--surface-color);
  d: path("M 40 80 c 22 0 40 -22 40 -40 v 40 Z");
}
.card_desing:hover .card_desing__header {
  transform: translateY(0);
}
.card_desing__thumb {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.card_desing__title {
  font-size: 1em;
  margin: 0 0 .3em;
  color: #6A515E;
}
.card_desing__tagline {
  display: block;
  margin: 1em 0;
  font-family: "MockFlowFont";
  font-size: .8em;
  color: #D7BDCA;
}
.card_desing__status {
  font-size: .8em;
  color: #D7BDCA;
}
.card_desing__description {
    padding: 0 2em 2em;
    margin: 0;
    color: #D7BDCA;
    font-family: "MockFlowFont";
    display:flex;
    justify-content: center;
    overflow: hidden;
}
</style>
